import auth from '../../middleware/auth';

export default {
	path: '/',
	name: 'mag-templates',
	props: {
		clientId: null
	},
	component: () => import('../../../views/MonitorActionGroupTemplates'),
	meta: {
		middleware: [
			auth
		]
	}
};
